import type { Translate } from '@/graphql/types/translate';

export function normalizeTranslateData(translate: Translate) {
  const flatten = (obj: any, prefix = ''): Record<string, string> => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === 'string') {
        acc[newKey] = value;
      } else if (typeof value === 'object' && value !== null) {
        Object.assign(acc, flatten(value, newKey));
      }
      return acc;
    }, {} as Record<string, string>);
  };
  return flatten(translate.data);
}
